var map = {
	"../pages/ambient/ambient.module": [
		353
	],
	"../pages/banner-alarm/banner-alarm.module": [
		833,
		1
	],
	"../pages/client/client.module": [
		213
	],
	"../pages/command/command.module": [
		834,
		0
	],
	"../pages/consulta/consulta.module": [
		219
	],
	"../pages/detail/detail.module": [
		349
	],
	"../pages/gauge/gauge.module": [
		214
	],
	"../pages/login/login.module": [
		215
	],
	"../pages/register/register.module": [
		351
	],
	"../pages/set-point/set-point.module": [
		217
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 210;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 210
// module chunks = 2